'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckValues = function () {
  function CheckValues() {
    _classCallCheck(this, CheckValues);
  }

  _createClass(CheckValues, null, [{
    key: 'CheckName',
    value: function CheckName(txt) //Überprüft, ob ein String nur aus Char- Zeichen besteht
    {
      if (txt !== null && txt !== undefined) {
        //let letters = /^[A-Za-zäöüÄÖÜß-\s]+$/;
        var letters = /^[\w'\-,.]*[^_!¡?÷?¿\/\\+=@#$%ˆ&*(){}|~<>;:[\]]*$/;
        if (txt.match(letters)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'CheckNumber',
    value: function CheckNumber(txt) {
      if (txt !== null && txt !== undefined) {
        var letters = /^[0-9]+$/;
        if (txt.match(letters)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'CheckTelNumber',
    value: function CheckTelNumber(txt) {
      if (txt !== null && txt !== undefined) {
        var letters = /^[0-9-/]+$/;
        if (txt.match(letters)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'CheckChar',
    value: function CheckChar(txt) {
      if (txt !== null && txt !== undefined) {
        var letters = /^[a-zA-ZäöüÄÖÜ]+$/;
        if (txt.match(letters)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'CheckGradeLevel',
    value: function CheckGradeLevel(txt) {
      if (txt !== null && txt !== undefined) {
        var letters = /^[0-9]+$/;
        if (txt.match(letters) && txt <= 12 && txt.length <= 2) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'CheckClass',
    value: function CheckClass(txt) {
      if (txt !== null && txt !== undefined) {
        var letters = /^[ABCD]+$/;
        if (txt.match(letters) && txt.length == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'checkAllFields',
    value: function checkAllFields(docs, me, Id) //Überprüft ob alle Felder bis zum aktuell verlassenen gefüllt sind
    {
      var aktive = false;
      for (var i = 0; i < docs.length; i++) {
        if (aktive === false) {
          if (docs[i].id === Id) {
            aktive = true;
          }
          for (var r in me) {
            if (docs[i].id === me[r].props.Id) {
              if (me[r].state !== null && me[r].state !== undefined) {
                if (me[r].state.isrequired !== null && me[r].state.isrequired !== undefined) {
                  if (me[r].state.isrequired === true) {
                    switch (docs[i].className) {
                      case 'textfield':
                        if (document.getElementById(docs[i].id).value.length === 0 || /^\s+$/.test(document.getElementById(me[r].props.Id).value)) {
                          me[r].setState({ required: false });
                        }
                        break;
                      case 'datefield':
                        if (document.getElementById(docs[i].id).value.length === 0) {
                          me[r].setState({ IsValid: false });
                        }
                        break;
                      case 'selectField':
                        if (document.getElementById(docs[i].id).selectedIndex <= 0) {
                          me[r].setState({ required: false });
                        }
                        break;
                      default:
                        break;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    //https://www.sharmaprakash.com.np/javascript/ie-alternative-to-inludes/# 18.02.2019

  }, {
    key: 'includes',
    value: function includes(container, value) {
      var returnValue = false;
      var pos = container.indexOf(value);
      if (pos >= 0) {
        returnValue = true;
      }
      return [returnValue, pos];
    }
  }, {
    key: 'doesNotInclude',
    value: function doesNotInclude(container, value) {
      var returnValue = false;
      var pos = container.indexOf(value);
      if (pos < 0) {
        returnValue = true;
      }
      return returnValue;
    }
  }, {
    key: 'CheckJSON',
    value: function CheckJSON(txt) {
      if (typeof txt !== "string") {
        return false;
      }
      try {
        JSON.parse(txt);
        return true;
      } catch (error) {
        return false;
      }
    }
  }]);

  return CheckValues;
}();

exports.default = CheckValues;